import getBreaksSummary from '@sdk/automatedBreaks/helpers/getBreaksSummary';

import { useClockedInViewContext } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/ClockedInViewProvider/ClockedInViewProvider';
import { getRelevantTimesheetEntries } from '@kiosk/automatedBreaks/helpers/getRelevantTimesheetEntries';

type Props = {
  clockIn: Date;
  clockOut: Date;
};

export const useAutomatedBreakEntries = ({ clockIn, clockOut }: Props) => {
  const { shift } = useClockedInViewContext();

  const entries = getRelevantTimesheetEntries(shift.timesheetEntries, clockIn, clockOut);
  const { breakRecords } = getBreaksSummary(entries, shift.dtstart, shift.dtend, []);

  return { breakRecords };
};
